export const NHACUNGCAP_LIST_INITING             = 'NHACUNGCAP_LIST_INITING'
export const NHACUNGCAP_LIST_REQUESTING          = 'NHACUNGCAP_LIST_REQUESTING'
export const NHACUNGCAP_LIST_SUCCESS             = 'NHACUNGCAP_LIST_SUCCESS'
export const NHACUNGCAP_LIST_ERROR               = 'NHACUNGCAP_LIST_ERROR'   

export const NHACUNGCAP_DETAIL_INITING           = 'NHACUNGCAP_DETAIL_INITING'
export const NHACUNGCAP_DETAIL_REQUESTING        = 'NHACUNGCAP_DETAIL_REQUESTING'
export const NHACUNGCAP_DETAIL_SUCCESS           = 'NHACUNGCAP_DETAIL_SUCCESS'
export const NHACUNGCAP_DETAIL_ERROR             = 'NHACUNGCAP_DETAIL_ERROR'   

export const NHACUNGCAP_UPDATE_REQUESTING        = 'NHACUNGCAP_UPDATE_REQUESTING'
export const NHACUNGCAP_UPDATE_SUCCESS           = 'NHACUNGCAP_UPDATE_SUCCESS'
export const NHACUNGCAP_UPDATE_ERROR             = 'NHACUNGCAP_UPDATE_ERROR'   

export const NHACUNGCAP_REMOVE_REQUESTING        = 'NHACUNGCAP_REMOVE_REQUESTING'
export const NHACUNGCAP_REMOVE_SUCCESS           = 'NHACUNGCAP_REMOVE_SUCCESS'
export const NHACUNGCAP_REMOVE_ERROR             = 'NHACUNGCAP_REMOVE_ERROR' 

export const NHACUNGCAP_DETAIL_API               = '/api/v1/management/nhacc_detail_by_id'  
export const NHACUNGCAP_LIST_API                 = '/api/v1/management/nhacc_list_by_store'   
export const NHACUNGCAP_UPDATE_API               = '/api/v1/management/nhacc_update_by_id' 
export const NHACUNGCAP_REMOVE_API                = '/api/v1/management/nhacc_remove_by_id'  


// WEBPACK FOOTER //
// ./src/views/NhaCC/constants.js